export const UserActionTypes = {
    USERS_PROFESSIONAL_LIST_GET: 'USERS_PROFESSIONAL_LIST_GET',
    USERS_PROFESSIONAL_LIST_GET_SUCCESSFUL: 'USERS_PROFESSIONAL_LIST_GET_SUCCESSFUL',
    USERS_PROFESSIONAL_LIST_GET_ERROR: 'USERS_PROFESSIONAL_LIST_GET_ERROR',

    USERS_PARENT_LIST_GET: 'USERS_PARENT_LIST_GET',
    USERS_PARENT_LIST_GET_SUCCESSFUL: 'USERS_PARENT_LIST_GET_SUCCESSFUL',
    USERS_PARENT_LIST_GET_ERROR: 'USERS_PARENT_LIST_GET_ERROR',

    USERS_PARENT_LIST_GET_EXEL: 'USERS_PARENT_LIST_GET_EXEL',
    USERS_PARENT_LIST_GET_EXEL_SUCCESSFUL: 'USERS_PARENT_LIST_GET_EXEL_SUCCESSFUL',
    USERS_PARENT_LIST_GET_EXEL_ERROR: 'USERS_PARENT_LIST_GET_EXEL_ERROR',

    SET_USERS_PROFESSIONAL_QUERY: 'SET_USERS_PROFESSIONAL_QUERY',
    RESET_USERS_PROFESSIONAL_QUERY: 'RESET_USERS_PROFESSIONAL_QUERY',
    SET_USERS_PARENT_QUERY: 'SET_USERS_PARENT_QUERY',
    RESET_USERS_PARENT_QUERY: 'RESET_USERS_PARENT_QUERY'
}




